module.exports = __webpack_public_path__ + "img/HeaderLogoLight.25239f05.svg";